var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Fragment, useCallback, useEffect, useMemo, useRef, } from "react";
import { createUseStyles } from "react-jss";
import { ListCell } from "../..";
import { useTableContext } from "../../hooks/useTableContext";
import { useTableWidth } from "../../hooks/useTableWidth";
import { classNames } from "../../utils/classNames";
import { DATA_COL_INDEX_DRAWER } from "../../utils/gridColumns";
import { DrawerTable } from "./DrawerTable";
import { getDrawerData } from "./utilsV2Table";
import { TABLE_CELL_STYLING } from "./TableCell";
export function TableDrawer(props) {
    var _a;
    var ref = useRef(null);
    var _b = useTableWidth(ref), width = _b.width, updateTableWidth = _b.updateTableWidth;
    var setTableWidth = useTableContext().setTableWidth;
    useEffect(function () {
        if (setTableWidth)
            setTableWidth(width);
    }, [width]);
    var classes = useTableDrawerClasses();
    var item = props.item, drawer = props.drawer, dropdown = props.dropdown;
    var drawerData = getDrawerData(item, drawer);
    var numberOfColumns = props === null || props === void 0 ? void 0 : props.headings.length;
    var colIndex = numberOfColumns + 1;
    var dataId = props.dataId, dataTestId = props.dataTestId;
    var rowKey = drawer === null || drawer === void 0 ? void 0 : drawer.rowKey;
    var isDrawerOpen = (_a = drawer === null || drawer === void 0 ? void 0 : drawer.openDrawers) === null || _a === void 0 ? void 0 : _a.some(drawersAreOpen(item, rowKey));
    var _c = React.useState(!!isDrawerOpen), drawerOpen = _c[0], setDrawerOpen = _c[1];
    var onDrawerChange = useCallback(function () {
        (drawer === null || drawer === void 0 ? void 0 : drawer.onDrawerOpen) && rowKey && (drawer === null || drawer === void 0 ? void 0 : drawer.onDrawerOpen(item[rowKey]));
        updateTableWidth();
        setDrawerOpen(!drawerOpen);
    }, [drawer, drawerOpen, item, rowKey, updateTableWidth]);
    var label = useMemo(function () {
        var _a;
        if ((drawer === null || drawer === void 0 ? void 0 : drawer.labelBuilder) && rowKey) {
            return drawer.labelBuilder(item[rowKey], drawerOpen);
        }
        return (_a = drawer === null || drawer === void 0 ? void 0 : drawer.label) !== null && _a !== void 0 ? _a : "Open";
    }, [drawer, drawerOpen, item, rowKey]);
    if ((drawer === null || drawer === void 0 ? void 0 : drawer.showDrawer) &&
        rowKey &&
        item[rowKey] &&
        !drawer.showDrawer(item[rowKey])) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(ListCell, { role: "cell", ariaColIndex: colIndex, className: classNames(classes.drawerToggle), dataHook: "table-drawer" },
            React.createElement("div", { role: "button", className: "btn btn-link list__drawer--action list__drawer--action--".concat(drawerOpen ? "open" : "closed"), "aria-expanded": drawerOpen, onClick: onDrawerChange, onKeyPress: onDrawerChange, "data-id": dataId && "".concat(dataId, "-drawer-").concat(props === null || props === void 0 ? void 0 : props.rowIndex), "data-testid": dataTestId && "".concat(dataTestId, "-drawer-").concat(props === null || props === void 0 ? void 0 : props.rowIndex), "data-hook": "table-drawer-action", style: { lineHeight: 1 } },
                React.createElement("span", { className: "list__drawer--action--title" }, label),
                React.createElement("span", { className: "glyphicon glyphicon-".concat(drawerOpen ? "chevron-up" : "chevron-down") }))),
        drawerOpen && (React.createElement("div", { role: "cell", "aria-colindex": dropdown ? numberOfColumns + 3 : numberOfColumns + 2, "data-colindex": dropdown ? numberOfColumns + 2 : numberOfColumns + 1, className: classNames(classes.cellDrawer, classes.tableDrawer, classes.drawerPagination), ref: ref, "data-hook": "table-drawer-contents" },
            (drawer === null || drawer === void 0 ? void 0 : drawer.headings) && (React.createElement(DrawerTable, { headings: drawer === null || drawer === void 0 ? void 0 : drawer.headings, data: drawerData, rowKey: rowKey && item[rowKey], pagination: drawer === null || drawer === void 0 ? void 0 : drawer.pagination, dataId: dataId && "".concat(dataId, "-nestedTable-").concat(props === null || props === void 0 ? void 0 : props.rowIndex), dataTestId: dataTestId && "".concat(dataTestId, "-nestedTable-").concat(props === null || props === void 0 ? void 0 : props.rowIndex) })),
            (drawer === null || drawer === void 0 ? void 0 : drawer.component) && rowKey && (React.createElement(TableDrawerComponent, { rowKey: rowKey, component: drawer.component, item: item }))))));
}
function drawersAreOpen(item, rowKey) {
    return function (open) { return rowKey && item[rowKey] === open; };
}
export function TableDrawerComponent(_a) {
    var component = _a.component, item = _a.item, rowKey = _a.rowKey;
    var formatter = function (value) {
        if (value !== null && value !== undefined && component) {
            return component(value);
        }
        return value;
    };
    return React.createElement(Fragment, null, formatter(item[rowKey]));
}
export function useTableDrawerClasses() {
    var useStyles = createUseStyles({
        tableDrawer: {
            marginTop: 4,
            "& .list__drawer--contents": {
                padding: 0,
                paddingTop: 0,
                paddingBottom: 0,
                "& > .list": {
                    margin: 0,
                },
            },
        },
        cellDrawer: {
            paddingRight: "0!important",
            gridArea: "".concat(DATA_COL_INDEX_DRAWER),
            "& .list__drawer--action": {
                paddingLeft: "4px !important",
                paddingRight: "4px !important",
            },
        },
        drawerPagination: {
            "& .pagination": {
                margin: "8px 0 2px",
            },
        },
        drawerToggle: __assign(__assign({}, TABLE_CELL_STYLING), { gridArea: "data-drawer-toggle", textAlign: "right" }),
    });
    return useStyles();
}
